module.exports = __webpack_public_path__ + "0d36d24737707e06cc51b801f6b4fc62.png";